<template>
  <div v-if="initiated" class="admin">
    <Menu />
    <h3>Promos</h3>
    <button @click="initNewPromo" class="bouton">Nouvelle Promo</button>
    <div class="promos" v-if="!newPromo">
      <fieldset :key="selectedPromo.id" v-for="selectedPromo in promos">
        <legend>{{ selectedPromo.name }}</legend>

        <div>
          Sexe: <strong>{{ sextext(selectedPromo.sex) }}</strong>
        </div>
        <div>
          Debut: <strong>{{ formatDate(selectedPromo.dateDebut) }}</strong>
        </div>
        <div>
          Fin: <strong>{{ formatDate(selectedPromo.dateFin) }}</strong>
        </div>
        <div>
          Prix Initial: <strong>{{ selectedPromo.product.price }}</strong>
        </div>
        <div>
          Durée Initiale (mois): <strong>{{ selectedPromo.product.monthDuration }}</strong>
        </div>
        <div>
          Durée Initiale (jours): <strong>{{ selectedPromo.product.monthDuration }}</strong>
        </div>
        <div>
          Prix Reconduction: <strong>{{ selectedPromo.product.productRenewal.price }}</strong>
        </div>
        <div>
          Période Recondution (mois): <strong>{{ selectedPromo.product.productRenewal.monthDuration }}</strong>
        </div>
        <div>
          Période Recondution (jours): <strong>{{ selectedPromo.product.productRenewal.dayDuration }}</strong>
        </div>
        <div class="section boutons">
          <button class="bouton" @click="deletePromo(selectedPromo)">Supprimer</button>
        </div>
      </fieldset>
    </div>
    <fieldset class="section" v-if="newPromo">
      <legend>Nouvelle Promo</legend>
      <fieldset class="promoset">
        <legend>Promo</legend>

        <div class="boutons">
          <input type="text" placeholder="Nom de la promo" v-model="newPromo.name" />
          <select v-model="newPromo.sex">
            <option value="BOTH">Tous</option>
            <option value="MALE">Hommes</option>
            <option value="FEMALE">Femme </option>
          </select>
          <select v-model="newPromo.targetType">
            <option v-for="tt of targetTypes" :value="tt" :key="`type${tt.id}`">
              {{ tt.name }}
            </option>
          </select>
          <label>Date début</label>
          <input v-model="newPromo.date_debut" class="bouton" type="date" placeholder="Date debut" />
          <label>Date fin</label>
          <input class="bouton" type="date" placeholder="Date fin" v-model="newPromo.date_fin" />
          <ImageInput @imageSelected="imageSelected"> Image </ImageInput>
          <ImageInput @imageSelected="imageSelectedMobile"> Image Mobile </ImageInput>
          <div class="imagePromo">
            <img v-if="newPromo.image" :src="newPromo.image" />
            <img v-if="newPromo.imageMobile" :src="newPromo.imageMobile" />
          </div>
        </div>
      </fieldset>
      <fieldset class="section">
        <legend>Prix et durées</legend>
        <div class="boutons">
          <input type="text" v-model="newPromo.initial_price" class="bouton" placeholder="Prix initial" />
          <number-input v-model="newPromo.initial_months" class="bouton" placeholder="Nb Mois initial" />
          <number-input v-model="newPromo.initial_days" class="bouton" placeholder="Nb Jours initial" />
          <label> Période de reconduction </label>
          <select v-model="newPromo.period_recond">
            <option :value="0">1 Mois</option>
            <option :value="1">3 Mois</option>
            <option :value="2">6 Mois </option>
            <option :value="6">1 An </option>
          </select>
          <input type="text" v-model="newPromo.recond_price" class="bouton" placeholder="Prix Reconduction" />
        </div>
      </fieldset>
      <div class="boutons">
        <button @click="savePromo" class="section bouton">Enregistrer</button>
        <button @click="newPromo = null" class="section bouton">Annuler</button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
import BasePage from "@/components/pages/BasePage";
import { idyuJsonRpc } from "../../assets/js/idyu/connect";
import NumberInput from "../util/NumberInput.vue";
import { idyuFormatDate, idyuFormatPrice } from "../../assets/js/idyu/util";
import ImageInput from "../util/ImageInput.vue";

export default {
  name: "AdminPromos",
  components: { Menu, NumberInput, ImageInput },
  extends: BasePage,

  data() {
    return {
      promos: [],
      newPromo: null,
      selectedPromo: null,
      targetTypes: [
        {
          id: 0,
          name: "Membres sans Pass"
        },
        {
          id: 1,
          name: "Membres en Renouvellement"
        },
        {
          id: 2,
          name: "Membres ayant vu le Bandeau"
        }
      ]
    };
  },

  methods: {
    imageSelected(base64) {
      this.newPromo.image = base64;
    },

    imageSelectedMobile(base64) {
      this.newPromo.imageMobile = base64;
    },

    sextext(id) {
      if (id == "MALE") {
        return "Hommes";
      }

      if (id === "FEMALE") {
        return "Femmes";
      }

      return "Tous";
    },

    async init() {
      this.promos = await idyuJsonRpc("getAllPromos");
    },

    formatDate(dateNumber) {
      return idyuFormatDate(dateNumber);
    },

    formatCost(dateNumber) {
      return idyuFormatPrice(dateNumber);
    },

    initNewPromo() {
      this.newPromo = {
        name: null,
        sex: "BOTH",
        targetType: this.targetTypes[0],
        date_debut: null,
        date_fin: null,
        initial_price: null,
        initial_months: null,
        initial_days: null,
        period_recond: null,
        recond_price: null,
        mailFreq: 0,
        popupFreq: 0,
        ageMin: -1,
        ageMax: -1,
        not: false,
        createdSince: -1,
        connectedSince: -1,
        image: null
      };
    },

    async savePromo() {
      await idyuJsonRpc(
        "createNewPromo",
        this.newPromo.name,
        this.newPromo.sex,
        this.newPromo.targetType.id,

        // Dates
        this.newPromo.date_debut,
        this.newPromo.date_fin,

        // Initial product
        this.newPromo.initial_price,
        this.newPromo.initial_months,
        this.newPromo.initial_days,

        // Renwal product
        this.newPromo.period_recond,
        this.newPromo.recond_price,
        this.newPromo.popupFreq,
        this.newPromo.ageMin,
        this.newPromo.ageMax,

        // Created/Connected
        this.newPromo.not,
        this.newPromo.createdSince,
        this.newPromo.connectedSince,

        this.newPromo.mailFreq,
        this.newPromo.image,
        this.newPromo.imageMobile
      );
      this.newPromo = null;
      this.init();
    },

    async deletePromo(promo) {
      if (await confirm("Etes vous sur de vouloir supprimer cette promo ?")) {
        await idyuJsonRpc("deleteNewPromo", promo.id);
        this.init();
      }
    },
    async editPromo(promo) {
      this.newPromo = promo;
    }
  },

  async created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.promos {
  display: flex;
  margin-top: 10px;
}
.promos > fieldset {
  width: 300px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.section {
  margin-top: 10px;
}

input[type="date"] {
  padding-left: 10px;
}

input[type="number"] {
  padding-left: 10px;
  padding-right: 5px;
}

.boutons {
  width: 300px;
  display: grid;
  grid-template-rows: auto;
  grid-gap: 10px;
}
.imagePromo {
  img {
    max-height: 150px;
  }
  position: absolute;
  top: 10px;
  right: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
}

.promoset {
  position: relative;
}
</style>
